import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("jassi_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return null;
        }
        try {
            const { data } = await apiClient.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            localStorage.removeItem("jassi_token");
            setUser(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await apiClient.post("/auth/login", { email, password });
        localStorage.setItem("jassi_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await apiClient.post("/auth/logout"); } catch {}
        localStorage.removeItem("jassi_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
